import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Movie } from "@/mocks/movies";

interface MovieGridSectionProps {
  eyebrow: string;
  title: string;
  description: string;
  moreTo: string;
  items: Movie[];
}

export default function MovieGridSection({
  eyebrow,
  title,
  description,
  moreTo,
  items,
}: MovieGridSectionProps) {
  return (
    <section className="w-full max-w-page mx-auto px-4 md:px-8 mt-14 md:mt-20">
      <SectionHeading eyebrow={eyebrow} title={title} description={description} moreTo={moreTo} moreLabel="进入分类" />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {items.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}